module.exports = __webpack_public_path__ + "img/westconnect.2b8c5c90.png";